export default __webpack_public_path__ + "static/media/book.fbdfb699.svg";